/* Phase 21 â Consultation modal accessibility (Phase 18 contact JS removed; native Liquid links) */
(function () {
  function initConsultationModal() {
    var popup = document.getElementById('product-popup');
    if (!popup || popup.dataset.twlModalBound === 'true') return;
    popup.dataset.twlModalBound = 'true';

    var trigger = document.getElementById('custbtn');
    var closeBtn = popup.querySelector('.close-popup');
    var popupContent = popup.querySelector('.popup-content');
    var form = popup.querySelector('#OrderForm');
    var submitBtn = form && form.querySelector('button[type="submit"]');
    var lastFocused = null;

    if (!popup.getAttribute('role')) popup.setAttribute('role', 'dialog');
    if (!popup.getAttribute('aria-modal')) popup.setAttribute('aria-modal', 'true');
    if (!popup.getAttribute('aria-labelledby')) {
      popup.setAttribute('aria-labelledby', 'product-popup-heading');
    }

    function isOpen() {
      return popup.style.display === 'flex';
    }

    function getFocusable(container) {
      return Array.prototype.slice
        .call(
          container.querySelectorAll(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        });
    }

    function openModal() {
      lastFocused = document.activeElement;
      popup.style.display = 'flex';
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflowY = 'hidden';
      var focusables = getFocusable(popupContent || popup);
      window.setTimeout(function () {
        if (focusables.length) focusables[0].focus();
      }, 0);
    }

    function closeModal() {
      popup.style.display = 'none';
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflowY = '';
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onDocumentKeyDown(event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusables = getFocusable(popupContent || popup);
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    popup.setAttribute('aria-hidden', isOpen() ? 'false' : 'true');

    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal();
      });
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup) closeModal();
    });

    document.addEventListener('keydown', onDocumentKeyDown);

    if (form && submitBtn) {
      form.addEventListener('submit', function () {
        submitBtn.disabled = true;
        submitBtn.classList.add('twl-modal-submit--loading');
        submitBtn.setAttribute('aria-busy', 'true');
      });
    }

    if (window.location.href.indexOf('?contact_posted=true#OrderForm') !== -1) {
      openModal();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConsultationModal);
  } else {
    initConsultationModal();
  }
})();
